import IngredientSuggestions from '../../ModalSuggestions/IngredientSuggestions';
import SelfieSuggestions from '../../ModalSuggestions/SelfieSuggestions';
import {base64ToBlob} from '../../../../utils/Base64ToBlob';
import CardSuggestions from '../../ModalSuggestions/CardSuggestions';
import PassportSuggestions from '../../ModalSuggestions/PassportSuggestions';
import FaceValidationSuggestions from '../../ModalSuggestions/FaceValidationSuggestions';
import {
    ImgAvoidGlare,
    ImgClearImage,
    ImgFaceCamera,
    ImgFlatSurface,
    ImgFullDocument,
    ImgFullPage,
    ImgFullVisibility,
    ImgGoodLighting,
    ImgNoObstruction,
    ImgOnlyYou,
    ImgOpenPassport,
    ImgPlaceId
} from '../../../buttons/IconButtons';
import { URL } from "../../../../Apis/Constants";
import MaterialAndEquipmentSuggestions from '../../ModalSuggestions/MaterialAndEquipmentSuggestions';

export const PHOTO_PICKER_MODEL = {
    id: null, // id of the image or file
    // image
    selfieSrc: null, // src taken from the webcam
    previewImage: null, // preview of a saved file, image obtained from the API
    // files
    fileSelected: null, // stores the file selected from the computer
    srcSelected: null, // file from URL.createObjectURL used to preview the selected image, already handled by the component
    preview: null, // preview of a file in the PhotoPickerUpload, or a default file like an apple icon in the case of Foodie
    listFiles: [],
    toSet: function (item){

        return {
            ...this,
            id: item.id,
            fileSelected: {
                name: item?.fileUploadDto?.userFileNames?.[0] || "unknown",
                size: item?.fileUploadDto?.size || 0,
                url: URL + item?.fileUploadDto?.filePath,
            }
        }
    }
}

export const SUGGESTION_MODE_OPTION = {
    INGREDIENTS: {
        SIZE: 'xs',
        TITLE: "take_a_photo_copying_this_angle",
        CONTENT: <IngredientSuggestions />
    },
    MATERIAL_AND_EQUIPMENT: {
        SIZE: 'xs',
        TITLE: "take_a_photo_copying_this_angle",
        CONTENT: <MaterialAndEquipmentSuggestions />
    },
    SELFIE: {
        SIZE: 'lg',
        TITLE: "selfie_suggestions_title",
        CONTENT: <SelfieSuggestions />,
    },
    FACE_VALIDATION_SELFIE: {
        SIZE: 'lg',
        TITLE: "how_to_take_a_photo_for_face_validation",
        CONTENT: <FaceValidationSuggestions />,
    },
    PASSPORT: ({ guardFlowId }) => {
        return {
            SIZE: 'lg',
            TITLE: guardFlowId ? "how_to_take_a_photo_of_the_passport" : "how_to_take_a_photo_of_your_passport",
            CONTENT: <PassportSuggestions/>,
        }
    },
    CARD: ({ guardFlowId }) => {
        return {
            SIZE: 'lg',
            TITLE: guardFlowId ? "how_to_take_a_photo_of_the_id_document" : "how_to_take_a_photo_of_your_id_document",
            CONTENT: <CardSuggestions/>,
        }
    }
}

export const SUGGESTION_MODEL_CONTENT = {
    PASSPORT: (guardFlowId) => {
        return [
            {
                number: 1,
                title: "open_the_passport_to_the_photo_page",
                subtitle: guardFlowId ? "ensure_the_full_photo_page_with_personal_details_is_visible" : "make_sure_the_entire_page_with_your_photo_and_personal_details_is_visible",
                Icon: ImgOpenPassport,
            },
            {
                number: 2,
                title: "place_it_on_a_flat_well_lit_surface",
                subtitle: "use_natural_light_and_avoid_shadows_or_glare",
                Icon: ImgFlatSurface,
            },
            {
                number: 3,
                title: "make_sure_the_image_is_sharp_and_clear",
                subtitle: "hold_the_camera_steady_all_text_must_be_easy_to_read",
                Icon: ImgClearImage,
            },
            {
                number: 4,
                title: "capture_the_full_page",
                subtitle: "don_t_crop_edges_or_cover_any_part_of_the_passport",
                Icon: ImgFullPage,
            },
        ]
    },
    FACE_VALIDATION_SELFIE: (guardFlowId) => {
        if(guardFlowId)
            return [
                {
                    number: 1,
                    title: "find_a_well_lit_area",
                    subtitle: "use_natural_or_soft_light_avoid_shadows_or_back_lighting",
                    Icon: ImgGoodLighting,
                },
                {
                    number: 2,
                    title: "make_sure_visitor_faces_the_camera_directly",
                    subtitle: "their_head_should_be_straight",
                    Icon: ImgFaceCamera,
                },
                {
                    number: 3,
                    title: "ensure_the_face_is_fully_visible",
                    subtitle: "remove_glasses_hats_or_anything_covering_the_face",
                    Icon: ImgFullVisibility,
                },
                {
                    number: 4,
                    title: "keep_the_frame_clear",
                    subtitle: "only_visitor_should_appear_in_the_photo",
                    Icon: ImgOnlyYou,
                },
            ];

        return [
            {
                number: 1,
                title: "find_a_well_lit_area",
                subtitle: "use_natural_or_soft_light_avoid_shadows_or_back_lighting",
                Icon: ImgGoodLighting,
            },
            {
                number: 2,
                title: "face_the_camera_directly",
                subtitle: "keep_your_head_straight_eyes_open_and_look_directly_at_the_camera",
                Icon: ImgFaceCamera,
            },
            {
                number: 3,
                title: "make_sure_your_face_is_fully_visible",
                subtitle: "remove_glasses_hats_or_anything_covering_your_face",
                Icon: ImgFullVisibility,
            },
            {
                number: 4,
                title: "only_you_should_be_in_the_frame",
                subtitle: "make_sure_no_other_people_or_objects_appear_in_the_photo",
                Icon: ImgOnlyYou,
            },
        ]
    },
    CARD: (guardFlowId) => {
        return [
            {
                number: 1,
                title: guardFlowId ? "place_the_id_on_a_flat_well_lit_surface" : "place_your_id_on_a_flat_well_lit_surface",
                subtitle: "use_a_clean_background_and_avoid_shadows",
                Icon: ImgPlaceId,
            },
            {
                number: 2,
                title: "capture_the_entire_document",
                subtitle: "make_sure_all_four_corners_are_visible_in_the_frame",
                Icon: ImgFullDocument,
            },
            {
                number: 3,
                title: "avoid_glare_and_reflections",
                subtitle: "use_natural_or_indirect_light_to_keep_the_image_clear",
                Icon: ImgAvoidGlare,
            },
            {
                number: 4,
                title: "don_t_block_any_part_of_the_id",
                subtitle: "ensure_fingers_or_objects_arent_covering_important_info",
                Icon: ImgNoObstruction,
            }
        ]
    }
}

export const getPhotoPicker = (photoPicker) => {
    return photoPicker.fileSelected !== null ? photoPicker.fileSelected : photoPicker?.selfieSrc != null ? base64ToBlob(photoPicker.selfieSrc) : null
}

